import { Button, ToolbarButton } from "@fluentui/react-components";
import { Document16Regular } from "@fluentui/react-icons";
import { ConstantValues } from "common/constants";

export const ChartExportToCSV = ({
  lineChartData,
  columns,
}: {
  lineChartData: any;
  columns: Array<string>;
}): JSX.Element => {
  const exportDataToCsv = () => {
    let csvData: string = ConstantValues.EMPTY_STRING;

    for (const column of columns) {
      csvData += `${column},`;
    }
    csvData = csvData.slice(0, -1) + "\n";
    for (let chartData of lineChartData?.lineChartData) {
      for (let lineData of chartData?.data) {
        let currentX = lineData?.x;
        if (currentX instanceof Date && !isNaN(currentX.getTime())) {
          currentX = currentX.toISOString().substring(0, 10);
        }
        csvData += `${currentX},${lineData?.y},${chartData?.legend}\n`;
      }
    }
    return new Blob([csvData], { type: "text/csv" });
  };

  return (
    <Button
      appearance="secondary"
      style={{ width: "180px", height: "30px" }}
      icon={<Document16Regular />}
    >
      <a
        download={`${lineChartData?.chartTitle}.csv`}
        target="_blank"
        rel="noreferrer"
        href={URL.createObjectURL(exportDataToCsv())}
        style={{
          textDecoration: "inherit",
          color: "inherit",
        }}
      >
        Export to Excel
      </a>
    </Button>
  );
};
